<template>
  <button class="Drop-Menu-Item" @click="toPinPost">
    <div class="Drop-Menu-Item__svg-box">
      <LoaderCircle :color="'var(--blue-600)'" :size="25" v-if="isLoading" />
      <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-else>
        <path d="M8.37658 15.6162L2.71973 21.273M11.6943 6.64169L10.1334 8.20258C10.0061 8.3299 9.9424 8.39357 9.86986 8.44415C9.80548 8.48905 9.73604 8.52622 9.66297 8.55488C9.58065 8.58717 9.49236 8.60482 9.3158 8.64014L5.65133 9.37303C4.69903 9.56349 4.22288 9.65872 4.00012 9.90977C3.80605 10.1285 3.71743 10.4212 3.75758 10.7108C3.80367 11.0433 4.14703 11.3866 4.83375 12.0733L11.9195 19.1591C12.6062 19.8458 12.9496 20.1891 13.282 20.2352C13.5716 20.2754 13.8643 20.1868 14.083 19.9927C14.3341 19.7699 14.4293 19.2938 14.6198 18.3415L15.3527 14.677C15.388 14.5005 15.4056 14.4122 15.4379 14.3298C15.4666 14.2568 15.5038 14.1873 15.5487 14.123C15.5992 14.0504 15.6629 13.9868 15.7902 13.8594L17.3511 12.2985C17.4325 12.2171 17.4732 12.1764 17.518 12.1409C17.5577 12.1093 17.5998 12.0808 17.6439 12.0557C17.6935 12.0273 17.7464 12.0046 17.8522 11.9593L20.3466 10.8903C21.0743 10.5784 21.4381 10.4225 21.6034 10.1705C21.7479 9.95013 21.7996 9.68163 21.7473 9.42335C21.6874 9.12801 21.4075 8.8481 20.8477 8.28827L15.7045 3.14514C15.1447 2.58531 14.8648 2.3054 14.5695 2.24552C14.3112 2.19317 14.0427 2.24488 13.8223 2.38941C13.5703 2.55469 13.4144 2.91854 13.1025 3.64624L12.0335 6.14059C11.9882 6.24641 11.9655 6.29932 11.9372 6.34893C11.912 6.393 11.8835 6.4351 11.8519 6.47484C11.8164 6.51958 11.7757 6.56029 11.6943 6.64169Z" stroke="var(--gray-600)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    {{ get_btnTxt }}
  </button>
</template>

<script setup>
  import { ref, computed, defineProps } from 'vue';
  import { useStore } from 'vuex';
  import { Props } from './scripts/props.js';
  import { pinPost } from './api/pinPost.js';
  import { callOverlay } from '@/Groups/OverlayManager/public/utils/callOverlay.js';
  //--------------------------------------------
  import LoaderCircle from '@ui/Loaders/LoaderCircle/LoaderCircle.vue';
  //--------------------------------------------
  const store = useStore();
  const props = defineProps(Props());
  //--------------------------------------------
  const ID = props.postId;
  //--------------------------------------------
  const isLoading = ref(false);
  //--------------------------------------------
  //Получить пост для добавления в избраннное
  const get_post = computed(() => store.state.ContentSystem.Alpha.list[ID]);
  //Закреплен ли пост в течении дня?
  const get_isPinned = computed(() => get_post.value.pinned_day);
  //Получить текст кнопки
  const get_btnTxt = computed(() => get_isPinned.value ? 'Открепить' : 'Закрепить');
  //--------------------------------------------
  //Закрепить/Открепить пост
  const toPinPost = async() => {
    if(isLoading.value) return;
    const isUsePin = !get_isPinned.value;
    try {
      toToggleLoading(true);
      const data = {
        object_id: get_post.value.id,
        content_type_id: get_post.value.content_type,
      }
      await pinPost(data, isUsePin);
      get_post.value.pinned_day = isUsePin;
      toMovePost();
      const overlayText = isUsePin ? 'Пост был успешно прикрплен' : 'Пост был откреплен';
      callOverlay({ text: overlayText, color: 'green', icon: 'pin' });
    } catch (error) {
      console.error('Ошибка при попытке прикрепить пост', error);
      const overlayText = isUsePin ? 'Ошибка при прикреплении поста' : 'Ошибка при откреплении поста';
      callOverlay({ text: overlayText, color: 'red', icon: 'pin' });
    } finally{
      toToggleLoading(false);
    }
  }
  //Переместить закрепленный/открепленный пост в начало/обратно на место
  const toMovePost = () => {
    store.commit('ContentSystem/Alpha/sortRenderMap');
  }
  //Изменинить статус отправки на сервер
  const toToggleLoading = (status) => {
    isLoading.value = status;
  }
</script>

<style lang="scss">
  @import '../../../../styles/Drop-Menu-Item.scss';
</style>